(function(){
  if(customElements.get('hovden-native-picker')) return;

  const money=new Intl.NumberFormat('nb-NO',{style:'currency',currency:'NOK',maximumFractionDigits:0});
  window.__hovdenTextileSelection=window.__hovdenTextileSelection||{};
  window.__hovdenLegSelection=window.__hovdenLegSelection||{};
  window.__hovdenSideSelection=window.__hovdenSideSelection||{};
  window.__hovdenExpandedGroups=window.__hovdenExpandedGroups||{};

  class HovdenNativePicker extends HTMLElement{
    connectedCallback(){
      this.productId=this.dataset.productId;
      this.config=this.readJson('[data-hovden-config]')||{};
      this.expanded=window.__hovdenExpandedGroups[this.productId]||{};
      this.bind();
      this.bindLightbox();
      this.renderLegPicker();
      this.renderSidePicker();
      this.restoreLeg();
      this.restoreSide();
      this.restoreTextile();
      this.refresh();
      this.onVariantChanged=()=>{
        this.refresh();
        setTimeout(()=>this.restoreTextile(),150);
        setTimeout(()=>this.restoreTextile(),500);
      };
      document.addEventListener('variant:changed',this.onVariantChanged);
      this.pickerObserver=new MutationObserver(mutations=>{
        const pickerContentChanged=mutations.some(mutation=>
          Array.from(mutation.addedNodes).some(node=>
            node.nodeType===1&&(
              node.matches?.('variant-selects,[data-hovden-textile-property]')||
              node.querySelector?.('variant-selects,[data-hovden-textile-property]')
            )
          )
        );
        if(pickerContentChanged) setTimeout(()=>{
          this.refresh();
          this.restoreTextile();
        },0);
      });
      this.pickerObserver.observe(this,{childList:true,subtree:true});
      const productInfo=this.closest('product-info');
      if(productInfo){
        this.productObserver=new MutationObserver(()=>{
          const savedTextile=this.getSavedTextile();
          if(savedTextile) this.syncTextileProperty(savedTextile.name);
          const savedLeg=this.getSavedLeg();
          if(savedLeg) this.syncLegProperty(savedLeg.key);
          const savedSide=this.getSavedSide();
          if(savedSide) this.syncSideProperty(savedSide.key);
        });
        this.productObserver.observe(productInfo,{childList:true,subtree:true});
      }
    }

    disconnectedCallback(){
      if(this.onVariantChanged) document.removeEventListener('variant:changed',this.onVariantChanged);
      document.removeEventListener('submit',this.onSubmit,true);
      document.removeEventListener('click',this.onPurchaseClick,true);
      document.removeEventListener('formdata',this.onFormData,true);
      this.pickerObserver?.disconnect();
      this.productObserver?.disconnect();
    }

    readJson(selector){
      try{return JSON.parse(this.querySelector(selector)?.textContent||'null')}
      catch(error){return null}
    }

    textileStorageKey(){return 'hovden-textile-'+this.productId}
    legStorageKey(){return 'hovden-leg-'+this.productId}
    sideStorageKey(){return 'hovden-side-'+this.productId}

    getSavedTextile(){
      if(window.__hovdenTextileSelection[this.productId]) return window.__hovdenTextileSelection[this.productId];
      try{
        const saved=JSON.parse(sessionStorage.getItem(this.textileStorageKey())||'null');
        if(saved) window.__hovdenTextileSelection[this.productId]=saved;
        return saved;
      }catch(error){return null}
    }

    getSavedLeg(){
      if(window.__hovdenLegSelection[this.productId]) return window.__hovdenLegSelection[this.productId];
      try{
        const saved=JSON.parse(sessionStorage.getItem(this.legStorageKey())||'null');
        if(saved) window.__hovdenLegSelection[this.productId]=saved;
        return saved;
      }catch(error){return null}
    }

    getSavedSide(){
      if(window.__hovdenSideSelection[this.productId]) return window.__hovdenSideSelection[this.productId];
      try{
        const saved=JSON.parse(sessionStorage.getItem(this.sideStorageKey())||'null');
        if(saved) window.__hovdenSideSelection[this.productId]=saved;
        return saved;
      }catch(error){return null}
    }

    getProductForm(){
      const marker=this.querySelector('[data-hovden-textile-property]');
      return document.getElementById(marker?.dataset.productFormId);
    }

    ensureProperty(name,dataKey){
      const form=this.getProductForm();
      if(!form) return null;
      let field=Array.from(form.elements).find(input=>input.name==='properties['+name+']');
      if(!field){
        field=document.createElement('input');
        field.type='hidden';
        field.name='properties['+name+']';
        field.setAttribute('data-'+dataKey,'');
        form.appendChild(field);
      }
      return field;
    }

    getValidTextile(){
      const saved=this.getSavedTextile();
      if(!saved||this.normalizeGroup(saved.group)!==this.normalizeGroup(this.selectedGroupValue())) return null;
      const button=Array.from(this.querySelectorAll('[data-hovden-textile]')).find(item=>
        item.dataset.hovdenTextile===saved.name&&item.dataset.hovdenTextileGroup===this.normalizeGroup(saved.group)
      );
      if(!button) return null;
      const code=button.dataset.hovdenTextileCode?.trim()||saved.name.match(/\b\d+\b/)?.[0]||'';
      return {name:button.dataset.hovdenTextile,group:button.dataset.hovdenTextileGroup,code,
        color:button.dataset.hovdenTextileColor?.trim()||code||button.dataset.hovdenTextile};
    }

    textileProperties(){
      const textile=this.getValidTextile();
      return {
        Tekstil:textile?.name||'',
        Tekstilgruppe:textile?.group||'',
        'Farge/kode':textile?.color||'',
        Tekstilkode:textile?.code||''
      };
    }

    ownsForm(form){
      if(!form?.matches?.('form[action*="/cart/add"]')) return false;
      if(form===this.getProductForm()) return true;
      return form.closest('sticky-atc-bar')?.dataset.productId===this.productId&&
        !this.closest('quick-view-modal');
    }

    syncPurchaseProperties(form){
      const properties=this.textileProperties();
      const leg=this.getSavedLeg();
      const side=this.getSavedSide();
      if(this.config.legs?.length) properties.Ben=leg?.key||'';
      if(this.config.side?.enabled) properties.Side=side?.key||'';
      Object.entries(properties).forEach(([name,value])=>{
        let field=Array.from(form.elements).find(input=>input.name==='properties['+name+']');
        if(!field){
          field=document.createElement('input');
          field.type='hidden';
          field.name='properties['+name+']';
          form.appendChild(field);
        }
        field.value=value;
        field.disabled=!value;
      });
      return properties;
    }

    validatePurchase(form,event){
      const textile=this.getValidTextile();
      const side=this.getSavedSide();
      const missingSide=!!(this.config.side?.enabled&&this.config.side.required&&
        !this.config.side.values?.includes(side?.key));
      const options=Array.from(this.querySelectorAll('variant-selects fieldset input[type=radio]:checked')).map(input=>input.value);
      const variant=(this.readJson('[data-hovden-variants]')||[]).find(item=>
        String(item.id)===String(form.elements.namedItem('id')?.value)&&
        item.available&&item.options.length===options.length&&item.options.every((value,index)=>value===options[index])
      );
      this.syncPurchaseProperties(form);
      const message=this.querySelector('[data-hovden-validation]');
      const sideMessage=this.querySelector('[data-hovden-side-validation]');
      if(message){
        message.hidden=!!textile&&!!variant;
        message.textContent=!textile?this.dataset.textileRequired:this.dataset.variantPending;
      }
      if(sideMessage) sideMessage.hidden=!missingSide;
      if(textile&&!missingSide&&variant) return true;
      event.preventDefault();
      event.stopImmediatePropagation();
      const target=!textile||!variant?message:sideMessage;
      target?.scrollIntoView({behavior:'smooth',block:'center'});
      return false;
    }

    syncTextileProperty(value){
      this.dataset.hovdenSelectedTextile=value;
      const marker=this.querySelector('[data-hovden-textile-property]');
      if(marker){marker.value=value;marker.setAttribute('value',value)}
      const field=this.ensureProperty('Tekstil','hovden-form-textile-property');
      if(field){field.value=value;field.setAttribute('value',value)}
      const form=this.getProductForm();
      if(form) this.syncPurchaseProperties(form);
      return field;
    }

    syncLegProperty(value){
      this.dataset.hovdenSelectedLeg=value;
      const field=this.ensureProperty('Ben','hovden-form-leg-property');
      if(field){field.value=value;field.setAttribute('value',value)}
      return field;
    }

    syncSideProperty(value){
      this.dataset.hovdenSelectedSide=value;
      const field=this.ensureProperty('Side','hovden-form-side-property');
      if(field){field.value=value;field.setAttribute('value',value)}
      return field;
    }

    normalizeGroup(value){return String(value||'A').replace(/\+$/,'').toUpperCase()}
    isPremiumGroup(value){return /\+$/.test(String(value||''))}
    isPremiumLeg(key){return key&&key!==(this.config.leg_default||'Sort kunstskinn')}

    selectedGroupValue(){
      const input=this.querySelector('[data-hovden-option="Stoffgruppe"] input[type=radio]:checked');
      return input?.value||'A';
    }

    setGroup(group){
      const savedLeg=this.getSavedLeg();
      const premium=this.isPremiumLeg(savedLeg?.key);
      const target=premium?group+'+':group;
      const radio=Array.from(this.querySelectorAll('[data-hovden-option="Stoffgruppe"] input[type=radio]'))
        .find(input=>input.value.toUpperCase()===target.toUpperCase());
      if(radio&&!radio.checked){
        radio.checked=true;
        radio.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }

    syncLegPriceClass(){
      this.setGroup(this.normalizeGroup(this.selectedGroupValue()));
    }

    bind(){
      this.addEventListener('keydown',event=>{
        const zoom=event.target.closest('[data-hovden-zoom]');
        if(zoom&&(event.key==='Enter'||event.key===' ')){
          event.preventDefault();
          event.stopPropagation();
          this.openLightbox(zoom);
        }
      });
      this.addEventListener('click',event=>{
        const zoom=event.target.closest('[data-hovden-zoom]');
        if(zoom&&this.contains(zoom)){
          event.preventDefault();
          event.stopPropagation();
          this.openLightbox(zoom);
          return;
        }
        const textile=event.target.closest('[data-hovden-textile]');
        if(textile&&this.contains(textile)){
          this.chooseTextile(textile);
          return;
        }
        const toggle=event.target.closest('[data-hovden-toggle]');
        if(toggle&&this.contains(toggle)){
          const group=toggle.closest('[data-hovden-group]');
          const key=this.normalizeGroup(group.dataset.hovdenGroup);
          const next=group.dataset.expanded!=='true';
          group.dataset.expanded=String(next);
          this.expanded[key]=next;
          window.__hovdenExpandedGroups[this.productId]=this.expanded;
          toggle.textContent=next?'Vis færre':'Vis alle tekstiler';
          toggle.setAttribute('aria-expanded',String(next));
        }
      });

      this.addEventListener('change',event=>{
        const leg=event.target.closest('[data-hovden-leg-radio]');
        if(leg&&this.contains(leg)){
          this.chooseLeg(leg.value);
          return;
        }
        const side=event.target.closest('[data-hovden-side-radio]');
        if(side&&this.contains(side)){
          this.chooseSide(side.value);
          return;
        }
        const input=event.target.closest('variant-selects input[type=radio]');
        if(!input||!this.contains(input)) return;
        const option=input.closest('[data-hovden-option]');
        const label=option?.querySelector('[data-hovden-selected-label]');
        if(label) label.textContent=input.value;
        if(option?.dataset.hovdenOption==='Stoffgruppe'){
          const group=this.normalizeGroup(input.value);
          const saved=this.getSavedTextile();
          if(saved&&saved.group!==group) this.clearTextile();
        }
        setTimeout(()=>this.refresh(),0);
      });

      this.onSubmit=event=>{
        if(this.ownsForm(event.target)) this.validatePurchase(event.target,event);
      };
      this.onPurchaseClick=event=>{
        const trigger=event.composedPath().find(node=>node.matches?.(
          'button[type="submit"],input[type="submit"],.shopify-payment-button__button,shopify-accelerated-checkout'
        ));
        const form=trigger?.form||trigger?.closest('form');
        if(this.ownsForm(form)) this.validatePurchase(form,event);
      };
      this.onFormData=event=>{
        if(!this.ownsForm(event.target)) return;
        const properties=this.syncPurchaseProperties(event.target);
        Object.entries(properties).forEach(([name,value])=>{
          if(value) event.formData.set('properties['+name+']',value);
          else event.formData.delete('properties['+name+']');
        });
      };
      document.addEventListener('submit',this.onSubmit,true);
      document.addEventListener('click',this.onPurchaseClick,true);
      document.addEventListener('formdata',this.onFormData,true);
    }

    bindLightbox(){
      const dialog=this.querySelector('[data-hovden-lightbox]');
      if(!dialog||dialog.dataset.bound==='true') return;
      dialog.dataset.bound='true';
      dialog.querySelector('[data-hovden-lightbox-close]')?.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{
        if(event.target===dialog) dialog.close();
      });
    }

    openLightbox(trigger){
      const dialog=this.querySelector('[data-hovden-lightbox]');
      if(!dialog) return;
      const image=dialog.querySelector('[data-hovden-lightbox-image]');
      const title=dialog.querySelector('[data-hovden-lightbox-title]');
      const src=trigger.dataset.hovdenZoomSrc;
      const label=trigger.dataset.hovdenZoomTitle||'';
      if(image){
        image.src=src;
        image.alt=label;
      }
      if(title) title.textContent=label;
      if(typeof dialog.showModal==='function') dialog.showModal();
      else dialog.setAttribute('open','');
    }

    renderLegPicker(){
      const legs=Array.isArray(this.config.legs)?this.config.legs:[];
      if(!legs.length||this.querySelector('[data-hovden-legs]')) return;
      const fieldset=document.createElement('fieldset');
      fieldset.className='hovden-native-option hovden-native-legs';
      fieldset.dataset.hovdenLegs='';
      const defaultLeg=this.config.leg_default||'Sort kunstskinn';
      const surcharge=Number(this.config.leg_surcharge||0);
      const existingSteps=Array.from(this.querySelectorAll('.hovden-native-option__step')).map(el=>Number(el.textContent)||0);
      const legStep=(existingSteps.length?Math.max(...existingSteps):0)+1;
      fieldset.innerHTML='<legend class="hovden-native-option__legend"><span class="hovden-native-option__step">'+legStep+'</span><span class="hovden-native-option__heading">Velg ben</span><span class="hovden-native-option__selected" data-hovden-selected-leg></span></legend><div class="hovden-native-option__values"></div>';
      const values=fieldset.querySelector('.hovden-native-option__values');
      legs.forEach((leg,index)=>{
        const id='Hovden-leg-'+this.productId+'-'+index;
        const wrap=document.createElement('div');
        wrap.className='hovden-native-leg';
        const premium=leg.key!==defaultLeg;
        const extra=premium?(Number(leg.price||surcharge)||0):0;
        wrap.innerHTML='<input class="hovden-native-option__radio" type="radio" id="'+id+'" name="Hovden-leg-'+this.productId+'" value="'+this.escapeHtml(leg.key)+'" data-hovden-leg-radio><label class="hovden-native-option__label" for="'+id+'" title="'+this.escapeHtml(leg.key)+'"><img src="'+this.escapeHtml(leg.url||'')+'" alt="'+this.escapeHtml(leg.key)+'" width="136" height="96" loading="lazy"><span class="hovden-image-zoom" role="button" tabindex="0" aria-label="Vis større bilde av '+this.escapeHtml(leg.key)+'" data-hovden-zoom data-hovden-zoom-src="'+this.escapeHtml(leg.url||'')+'" data-hovden-zoom-title="'+this.escapeHtml(leg.key)+'">⌕</span></label><span class="hovden-native-leg__caption">'+this.escapeHtml(leg.key)+(extra>0?' <small>+'+money.format(extra)+'</small>':'')+'</span>';
        values.appendChild(wrap);
      });
      this.querySelector('variant-selects')?.insertAdjacentElement('afterend',fieldset);
    }

    renderSidePicker(){
      const side=this.config.side;
      if(!side?.enabled||!Array.isArray(side.values)||!side.values.length||this.querySelector('[data-hovden-side]')) return;
      const fieldset=document.createElement('fieldset');
      fieldset.className='hovden-native-option hovden-native-side';
      fieldset.dataset.hovdenSide='';
      const heading=this.escapeHtml(side.label||'Velg side');
      const help=this.escapeHtml(side.help||'Side angis sett forfra.');
      const mirrorNote=side.mirrorable===false?' Denne modulen kan ikke speilvendes.':'';
      const existingSteps=Array.from(this.querySelectorAll('.hovden-native-option__step')).map(el=>Number(el.textContent)||0);
      const sideStep=(existingSteps.length?Math.max(...existingSteps):0)+1;
      fieldset.innerHTML='<legend class="hovden-native-option__legend"><span class="hovden-native-option__step">'+sideStep+'</span><span class="hovden-native-option__heading">'+heading+'</span><span class="hovden-native-option__selected" data-hovden-selected-side></span></legend><p class="hovden-native-side__help">'+help+mirrorNote+'</p><div class="hovden-native-option__values"></div><p class="hovden-native-picker__validation" data-hovden-side-validation hidden>Velg venstre eller høyre side før du legger sofaen i handlekurven.</p>';
      const values=fieldset.querySelector('.hovden-native-option__values');
      side.values.forEach((value,index)=>{
        const id='Hovden-side-'+this.productId+'-'+index;
        const wrap=document.createElement('div');
        wrap.className='hovden-native-side__value';
        wrap.innerHTML='<input class="hovden-native-option__radio" type="radio" id="'+id+'" name="Hovden-side-'+this.productId+'" value="'+this.escapeHtml(value)+'" data-hovden-side-radio><label class="hovden-native-option__label" for="'+id+'"><span>'+this.escapeHtml(value)+'</span></label>';
        values.appendChild(wrap);
      });
      const legs=this.querySelector('[data-hovden-legs]');
      if(legs) legs.insertAdjacentElement('afterend',fieldset);
      else this.querySelector('variant-selects')?.insertAdjacentElement('afterend',fieldset);
    }

    chooseSide(key){
      const side=this.config.side;
      if(!side?.values?.includes(key)) return;
      const saved={key};
      window.__hovdenSideSelection[this.productId]=saved;
      try{sessionStorage.setItem(this.sideStorageKey(),JSON.stringify(saved))}catch(error){}
      this.syncSideProperty(key);
      const label=this.querySelector('[data-hovden-selected-side]');
      if(label) label.textContent=key;
      const message=this.querySelector('[data-hovden-side-validation]');
      if(message) message.hidden=true;
    }

    restoreSide(){
      const side=this.config.side;
      if(!side?.enabled) return;
      const saved=this.getSavedSide();
      if(!saved) return;
      const input=Array.from(this.querySelectorAll('[data-hovden-side-radio]')).find(item=>item.value===saved.key);
      if(input) input.checked=true;
      this.syncSideProperty(saved.key);
      const label=this.querySelector('[data-hovden-selected-side]');
      if(label) label.textContent=saved.key;
      window.__hovdenSideSelection[this.productId]=saved;
    }

    escapeHtml(value){
      return String(value||'').replace(/[&<>"]/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[char]));
    }

    chooseLeg(key){
      const leg=(this.config.legs||[]).find(item=>item.key===key);
      if(!leg) return;
      const saved={key:leg.key};
      window.__hovdenLegSelection[this.productId]=saved;
      try{sessionStorage.setItem(this.legStorageKey(),JSON.stringify(saved))}catch(error){}
      this.syncLegProperty(leg.key);
      const label=this.querySelector('[data-hovden-selected-leg]');
      if(label) label.textContent=leg.key;
      this.syncLegPriceClass();
    }

    restoreLeg(){
      const legs=Array.isArray(this.config.legs)?this.config.legs:[];
      if(!legs.length) return;
      const saved=this.getSavedLeg()||{key:this.config.leg_default||legs[0].key};
      const input=Array.from(this.querySelectorAll('[data-hovden-leg-radio]')).find(item=>item.value===saved.key);
      if(input) input.checked=true;
      this.syncLegProperty(saved.key);
      const label=this.querySelector('[data-hovden-selected-leg]');
      if(label) label.textContent=saved.key;
      window.__hovdenLegSelection[this.productId]=saved;
    }

    refresh(){
      const activeGroup=this.normalizeGroup(this.selectedGroupValue());
      const surcharges=this.config.textile_surcharges||{};
      this.querySelectorAll('[data-hovden-group]').forEach(group=>{
        const raw=group.dataset.hovdenGroup;
        if(this.isPremiumGroup(raw)) return;
        const key=this.normalizeGroup(raw);
        group.classList.toggle('is-selected',key===activeGroup);
        group.dataset.expanded=String(!!this.expanded[key]);
        const toggle=group.querySelector('[data-hovden-toggle]');
        if(toggle){
          toggle.textContent=this.expanded[key]?'Vis færre':'Vis alle tekstiler';
          toggle.setAttribute('aria-expanded',String(!!this.expanded[key]));
        }
        const price=group.querySelector('[data-hovden-group-price]');
        if(price){
          const difference=Number(surcharges[key]||0);
          price.textContent=key==='A'?'Inkludert':difference>0?'+'+money.format(difference):'';
        }
      });
      this.restoreLeg();
      this.restoreSide();
      this.restoreTextile();
    }

    chooseTextile(button){
      const group=button.dataset.hovdenTextileGroup;
      const name=button.dataset.hovdenTextile;
      const saved={name,group};
      window.__hovdenTextileSelection[this.productId]=saved;
      try{sessionStorage.setItem(this.textileStorageKey(),JSON.stringify(saved))}catch(error){}
      const validation=this.querySelector('[data-hovden-validation]');
      this.syncTextileProperty(name);
      if(validation) validation.hidden=true;
      this.querySelectorAll('[data-hovden-textile]').forEach(item=>{
        const selected=item===button;
        item.classList.toggle('is-selected',selected);
        item.setAttribute('aria-pressed',String(selected));
      });
      this.updateSelectedText(name,group);
      this.setGroup(group);
      const form=this.getProductForm();
      if(form) this.syncPurchaseProperties(form);
    }

    updateSelectedText(name,group){
      this.querySelectorAll('[data-hovden-selected-textile]').forEach(element=>{element.hidden=true;element.textContent=''});
      if(!name||!group) return;
      const line=this.querySelector('[data-hovden-group="'+group+'"] [data-hovden-selected-textile]');
      if(line){line.textContent='Valgt: '+name;line.hidden=false}
    }

    clearTextile(){
      delete window.__hovdenTextileSelection[this.productId];
      try{sessionStorage.removeItem(this.textileStorageKey())}catch(error){}
      this.syncTextileProperty('');
      this.querySelectorAll('[data-hovden-textile]').forEach(item=>{
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed','false');
      });
      this.updateSelectedText();
    }

    restoreTextile(){
      const saved=this.getSavedTextile();
      if(!saved){
        const form=this.getProductForm();
        if(form) this.syncPurchaseProperties(form);
        return;
      }
      const selectedGroup=this.normalizeGroup(this.selectedGroupValue());
      if(saved.group!==selectedGroup){
        const form=this.getProductForm();
        if(form) this.syncPurchaseProperties(form);
        return;
      }
      this.syncTextileProperty(saved.name);
      const button=Array.from(this.querySelectorAll('[data-hovden-textile]'))
        .find(item=>item.dataset.hovdenTextile===saved.name&&item.dataset.hovdenTextileGroup===saved.group);
      if(button){button.classList.add('is-selected');button.setAttribute('aria-pressed','true')}
      this.updateSelectedText(saved.name,saved.group);
    }
  }

  customElements.define('hovden-native-picker',HovdenNativePicker);
})();
